import _pt from "prop-types";
import tokens from '@datacamp/waffles-tokens';
import React from 'react';
import BaseDialog from '../BaseDialog';
import Body from '../shared/Body';
import Footer from '../shared/Footer';
import Header from '../shared/Header';
import StepsIndicator from './StepsIndicator';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Dialog = function Dialog(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? tokens.colors.white : _ref$backgroundColor,
      children = _ref.children,
      currentStep = _ref.currentStep,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      portalClassName = _ref.portalClassName,
      _ref$shouldCloseOnEsc = _ref.shouldCloseOnEsc,
      shouldCloseOnEsc = _ref$shouldCloseOnEsc === void 0 ? true : _ref$shouldCloseOnEsc,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve,
      totalSteps = _ref.totalSteps,
      width = _ref.width;
  return ___EmotionJSX(BaseDialog, {
    additionalContent: totalSteps && ___EmotionJSX(StepsIndicator, {
      currentStep: currentStep,
      totalSteps: totalSteps
    }),
    backgroundColor: backgroundColor,
    contentLabel: "Dialog",
    hideCloseButton: hideCloseButton,
    isOpen: isOpen,
    onClose: onClose,
    portalClassName: portalClassName,
    shouldCloseOnEsc: shouldCloseOnEsc,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    width: width
  }, children);
};

Dialog.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundColor: _pt.string,
  children: _pt.node.isRequired,
  currentStep: _pt.number,
  hideCloseButton: _pt.bool,
  isOpen: _pt.bool.isRequired,
  onClose: _pt.func.isRequired,
  portalClassName: _pt.string,
  shouldCloseOnEsc: _pt.bool,
  shouldCloseOnOverlayClick: _pt.bool,
  totalSteps: _pt.number,
  width: _pt.number.isRequired
} : {};
Dialog.Header = Header;
Dialog.Body = Body;
Dialog.Footer = Footer;
export default Dialog;